var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"field__content"},[_c('a-input',{attrs:{"type":"number","placeholder":_vm.placeholder},on:{"input":function($event){if (_vm.val.length > 11) {
        _vm.val = _vm.val.slice(0, 11);
      }},"blur":() => {
        _vm.refs.onFieldBlur();
      }},model:{value:(_vm.val),callback:function ($$v) {_vm.val=(typeof $$v === 'string'? $$v.trim(): $$v)},expression:"val"}},[_c('a-icon',{attrs:{"slot":"prefix","type":"phone"},slot:"prefix"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }